<template></template>

<script>
import Modal from '../../classes/modal.class';
export default {
  name: "SalvaRicercaModal",
  props: ['ricerca', 'titolo', 'sottoTitolo', 'source'],

  created () {
    const modal = new Modal({
      name: 'salva_ricerca',
      class: 'big-modal',
      component: 'salva-ricerca-wizard',
      padding: false,
      closeButton: true,
      callback: () => { this.$modal.hide('salva_ricerca'); },
      bind: {
        ricerca: this.ricerca,
        titolo: this.titolo,
        sottoTitolo: this.sottoTitolo,
        source: this.source,
      }
    });

    this.$root.modals.push(modal);
  },

  mounted () {
    // Mostro il modale SSE non ho un cookie che mi dice che l'utente ha già visto il modale
    if (this.hasCookie('salva_ricerca')) {
      return;
    }

    setTimeout(() => {
      this.$modal.show('salva_ricerca');
      this.setCookie('salva_ricerca', true, 2);
    }, 3000)
  },

  methods: {
    setCookie (name, value, hours) {
      var expires = "";
      if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    getCookie (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },

    hasCookie (name) {
      return this.getCookie(name) !== null;
    },
  }
}
</script>

<style>
.salva-ricerca {
  z-index: 999;
}
</style>

<style scoped>
.v--modal-box {
  height: auto !important;
  background-color: white;
}
</style>